@if (isAuthenticated()) {
  @if (isContentLayout() && !isOpen()) {
    <button
      type="button"
      class="chatbot-fab"
      (click)="toggle()"
      [attr.aria-label]="'assistantChatbot.open' | transloco"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        class="chatbot-fab__icon"
        aria-hidden="true"
      >
        <rect x="2" y="4" width="20" height="14" rx="3" fill="white" />
        <circle cx="8" cy="11" r="1.2" fill="currentColor" />
        <circle cx="12" cy="11" r="1.2" fill="currentColor" />
        <circle cx="16" cy="11" r="1.2" fill="currentColor" />
      </svg>
    </button>
  }
  <div class="chatbot-panel" [class.chatbot-panel--open]="isOpen()">
    <div class="chatbot-panel__header">
      <span class="chatbot-panel__title">{{ "assistantChatbot.title" | transloco }}</span>
      <button
        type="button"
        class="chatbot-panel__close"
        (click)="close()"
        [attr.aria-label]="'assistantChatbot.close' | transloco"
      >
        <i class="ft-x"></i>
      </button>
    </div>
    <div class="chatbot-panel__body">
      @if (safeUrl(); as src) {
        <iframe
          #chatbotIframe
          [src]="src"
          class="chatbot-panel__iframe"
          [attr.title]="'assistantChatbot.iframeTitle' | transloco"
          allow="microphone"
          (load)="onIframeLoad()"
        ></iframe>
      }
    </div>
  </div>
}
